import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  XrkTable,
  XrkTableProps,
  BaseButton,
  XrkTableRef,
  useInputColumn
} from 'xrk-components';
import { dealTableColumnstextLineClamp, delConfirm } from '../tools/index';
import { createDrugFormDialog } from '../components/drug-form';
import { Drug } from '../data-source/types';
import { computed, ref } from 'vue';
import { useZsStore } from '../store';
import {
  PRESCRIPTION_TYPE,
  PRESCRIPTION_TYPE_MAP,
  PRODUCT_DRUG
} from '../config';
import { deleteProduct, getProductList } from '../data-source/api';

type TableConfig = XrkTableProps<Drug['search'], Drug['row']>;


export default /*#__PURE__*/_defineComponent({
  __name: 'zs-manage-drug',
  setup(__props) {

const { isOwnPublish, isCsoRole, enterpriseId } = useZsStore();

const { TableRef, initList, initCurrentList } = (() => {
  const TableRef = ref<XrkTableRef>();
  return {
    TableRef,
    initList: () => TableRef.value?.initList(),
    initCurrentList: () => TableRef.value?.initCurrentList()
  };
})();

const searchConfig = computed(() => {
  const config: TableConfig['searchConfig'] = {
    searchColumns: [
      useInputColumn({
        prop: 'name',
        label: '药品名称',
        config: {
          maxlength: 20,
          clearable: true
        }
      }),
      useInputColumn({
        prop: 'approvalNumber',
        label: '批准文号',
        config: {
          maxlength: 20,
          clearable: true
        }
      }),
      {
        type: 'select',
        prop: 'isOtc',
        label: '是否处方药',
        config: {
          options: PRESCRIPTION_TYPE,
          clearable: true
        }
      }
    ],
    otherComponents: []
  };
  if (isCsoRole.value) {
    config.searchColumns.unshift({
      type: 'input',
      prop: 'enterpriseName',
      label: '工业名称'
    });
  }
  if (isOwnPublish.value) {
    config.otherComponents.push({
      render: () => (
        <BaseButton
          type="primary2"
          onClick={() => createDrugFormDialog({}, 'add', initList)}
        >
          新增
        </BaseButton>
      )
    });
  }
  return config;
});
const tableConfig = computed<TableConfig['tableConfig']>(() => {
  const config = {
    tableColumns: dealTableColumnstextLineClamp<
      TableConfig['tableConfig']['tableColumns']
    >([
      { type: 'index', label: '序号', width: 80 },
      {
        prop: 'isOtc',
        minWidth: 80,
        label: '是否处方药',
        formatter: ({ cellValue }) => PRESCRIPTION_TYPE_MAP[cellValue as any]
      },
      { prop: 'approvalNumber', minWidth: 80, label: '批准文号' },
      { prop: 'name', minWidth: 120, label: '药品名称' },
      { prop: 'productName', minWidth: 120, label: '商品名称' },
      { prop: 'medicineType', minWidth: 120, label: '药品类型' },
      { prop: 'jixing', minWidth: 120, label: '剂型' }
    ])
  };
  if (isCsoRole.value) {
    config.tableColumns.splice(1, 0, {
      prop: 'enterpriseList',
      label: '工业名称',
      minWidth: 300,
      render: ({ cellValue }) => {
        if (Array.isArray(cellValue)) {
          if (cellValue.length === 0) return <>-</>;
          return (
            <>
              {Array.from(new Set(cellValue)).map((item, index) => (
                <div style={{ padding: '3px 0', lineHeight: 1.2 }} key={index}>
                  {item}
                </div>
              ))}
            </>
          );
        }
        return <span>{cellValue || '-'}</span>;
      }
    });
  }
  if (isOwnPublish.value) {
    config.tableColumns.push({
      fixed: 'right',
      width: 150,
      label: '操作',
      render: ({ row }) => {
        return (
          <>
            <BaseButton
              type="text"
              disabled={!row.allowUpdate}
              onClick={() => createDrugFormDialog(row, 'edit', initCurrentList)}
            >
              编辑
            </BaseButton>
            <BaseButton
              type="text"
              disabled={!row.allowDelete}
              onClick={() =>
                delConfirm(async () => {
                  await deleteProduct({ id: row.id });
                  initCurrentList();
                })
              }
            >
              删除
            </BaseButton>
          </>
        );
      }
    } as TableConfig['tableConfig']['tableColumns'][number]);
  }
  return config;
});
const getList: TableConfig['getListAjax'] = async parmas => {
  return getProductList({
    ...parmas,
    enterpriseId: enterpriseId.value,
    type: PRODUCT_DRUG
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XrkTable), {
    ref_key: "TableRef",
    ref: TableRef,
    "search-config": searchConfig.value,
    "table-config": tableConfig.value,
    "get-list-ajax": getList
  }, null, 8, ["search-config", "table-config"]))
}
}

})